import styled from 'styled-components'
import * as ButtonBase from './ButtonBase'
import { colours } from '@qflow/theme'

const Basic = styled.button`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: colours.WHITE,
    getBgHover: colours.CORE_NAVY,
    getBgActive: ({ theme }) => theme.colourButton.defaultBgActive,
    getBgDisabled: ({ theme }) => theme.colourButton.defaultBg,
    getFg: ({ theme }) => theme.colourButton.defaultFg,
    getFgHover: colours.WHITE,
    getFgDisabled: ({ theme }) => theme.colourButton.defaultFgDisabled
  })}
  ${ButtonBase.getShapeCSS()}
  ${ButtonBase.getBorderCSS({
    getBorderFg: colours.BORDER_GREY,
    getBorderFgActive: colours.BORDER_GREY,
    getBorderFgHover: ({ theme }) => theme.colourButton.borderFgHover,
    getBorderFgDisabled: colours.CLOUD_GREY,
    withGlow: false
  })}
  ${ButtonBase.TakeCSSProp}
`

const BasicBorderless = styled.button`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: ({ theme }) => theme.colourButton.defaultBg,
    getBgHover: '#f0f0f0',
    getBgActive: colours.WHITE_10,
    getBgDisabled: ({ theme }) => theme.colourButton.defaultBg,
    getFg: ({ theme }) => theme.colourButton.defaultFg,
    getFgHover: ({ theme }) => theme.colourButton.defaultFg,
    getFgDisabled: ({ theme }) => theme.colourButton.defaultFgDisabled
  })}
  ${ButtonBase.getShapeCSS()}
  ${ButtonBase.getBorderCSS({
    getBorderFg: () => 'transparent',
    getBorderFgDisabled: () => 'transparent',
    getBorderFgHover: () => 'transparent',
    getBorderFgRadius: () => '5px',
    withGlow: false
  })}
  ${ButtonBase.TakeCSSProp}
`

const Negative = styled.button`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: ({ theme }) => theme.colourButton.negativeBg,
    getBgHover: ({ theme }) => theme.colourButton.negativeBgHover,
    getBgActive: ({ theme }) => theme.colourButton.negativeBgActive,
    getBgDisabled: ({ theme }) => theme.colourButton.defaultBg,
    getFg: ({ theme }) => theme.colourButton.negativeFg,
    getFgDisabled: ({ theme }) => theme.colourButton.negativeFgDisabled
  })}
  ${ButtonBase.getShapeCSS()}
  ${ButtonBase.getBorderCSS({
    withGlow: false,
    getBorderFgHover: () => 'transparent'
  })}
  ${ButtonBase.TakeCSSProp}
`
const NegativeSecondary = styled.button`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: colours.WHITE,
    getBgHover: colours.RED_DARKMODE,
    getBgActive: ({ theme }) => theme.colourButton.defaultBgActive,
    getBgDisabled: ({ theme }) => theme.colourButton.defaultBg,
    getFg: colours.RED_DARKMODE,
    getFgHover: colours.WHITE,
    getFgDisabled: ({ theme }) => theme.colourButton.defaultFgDisabled
  })}
  ${ButtonBase.getShapeCSS()}
  ${ButtonBase.getBorderCSS({
    getBorderFg: colours.BORDER_GREY,
    getBorderFgHover: colours.WHITE,
    getBorderFgDisabled: ({ theme }) => theme.colourButton.defaultFgDisabled,
    withGlow: false
  })}
  ${ButtonBase.TakeCSSProp}
`

const Action = styled.button`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: ({ theme }) => theme.colourButton.actionBg,
    getBgHover: ({ theme }) => theme.colourButton.actionBgHover,
    getBgActive: ({ theme }) => theme.colourButton.actionBgActive,
    getBgDisabled: ({ theme }) => theme.colourButton.actionBgDisabled,
    getFg: ({ theme }) => theme.colourButton.actionFg,
    getFgHover: ({ theme }) => theme.colourButton.actionFg,
    getFgDisabled: ({ theme }) => theme.colourButton.actionFgDisabled
  })}
  ${ButtonBase.getShapeCSS()}
  ${ButtonBase.getBorderCSS({
    withGlow: false,
    getBorderFgFocus: ({ theme }) => theme.colourButton.borderFgFocus,
    getBorderFgHover: colours.TEAL
  })}
  ${ButtonBase.TakeCSSProp}
`

const Caution = styled.button`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: ({ theme }) => theme.colourButton.cautionBg,
    getBgHover: ({ theme }) => theme.colourButton.cautionBgHover,
    getBgActive: ({ theme }) => theme.colourButton.cautionBgActive,
    getBgDisabled: ({ theme }) => theme.colourButton.defaultBg,
    getFg: ({ theme }) => theme.colourButton.cautionFg,
    getFgHover: ({ theme }) => theme.colourButton.cautionFg,
    getFgDisabled: ({ theme }) => theme.colourButton.cautionFgDisabled
  })}
  ${ButtonBase.getShapeCSS()}
  ${ButtonBase.getBorderCSS({
    withGlow: false,
    getBorderFg: ({ theme }) => theme.colourButton.cautionBorder,
    getBorderFgHover: ({ theme }) => theme.colourButton.cautionBorderHover
  })}
  ${ButtonBase.TakeCSSProp}
`

const Trigger = styled.button`
  ${ButtonBase.BaseCSS}
  ${ButtonBase.getColoursCSS({
    getBg: colours.PALE_TEAL,
    getBgHover: colours.LIGHT_TEAL,
    getBgActive: colours.LIGHT_TEAL,
    getBgDisabled: '#f0fff0',
    getFg: colours.CHARCOAL_GREY,
    getFgHover: colours.CORE_NAVY,
    getFgDisabled: ({ theme }) => theme.colourButton.defaultFgDisabled
  })}
  ${ButtonBase.getShapeCSS()}
  ${ButtonBase.getBorderCSS({
    getBorderFg: `${colours.TEAL}99`,
    getBorderFgActive: `${colours.TEAL}CC`,
    getBorderFgHover: `${colours.TEAL}CC`,
    getBorderFgDisabled: colours.BORDER_GREY,
    withGlow: false
  })}
  ${ButtonBase.TakeCSSProp}
`

export const ColourButton = {
  Basic,
  BasicBorderless,
  Negative,
  NegativeSecondary,
  Action,
  Caution,
  Trigger
}
